import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { PageBannerModule } from '@hiptraveler/features/page-banner';
import { ActivityDateListModule, ActivityDayListModule, ComponentStateService, ItineraryStateService, TravelDetailsModule, TravelOptionsModule, TravelShareHandlesModule, SkeletonModule } from '@hiptraveler/features/itinerary';
import { ItineraryDateViewMapModule } from '@hiptraveler/features/leaflet-map';
import { SafeHtmlPipeModule } from '@hiptraveler/common';

import { TravelStoryComponent } from './travel-story.component';
import { NavbarActionListenerDirective } from './navbar-action-listener.directive';

const MODULES = [
  CommonModule,
  TranslateModule
];

const LIBRARIES = [
  PageBannerModule,
  ActivityDateListModule,
  ActivityDayListModule,
  TravelDetailsModule,
  TravelOptionsModule,
  TravelShareHandlesModule,
  ItineraryDateViewMapModule,
  SkeletonModule,
  SafeHtmlPipeModule
];

const PROVIDERS = [
  ItineraryStateService,
  ComponentStateService
];

const COMPONENTS = [
  TravelStoryComponent
];

const DIRECTIVES = [
  NavbarActionListenerDirective
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES,
    RouterModule.forChild([{
      path: '', component: TravelStoryComponent
    }])
  ],
  providers: [
    PROVIDERS
  ],
  declarations: [
    COMPONENTS,
    DIRECTIVES
  ]
})
export class TravelStoryModule { }
